export default function Testimonial() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-3 space-y-8">
            <div>
              <div className="flex items-center gap-2 mb-6">
                <div className="w-2 h-2 bg-gray-900 rounded-full"></div>
                <span className="text-sm font-medium text-gray-600">お客様の声</span>
              </div>
              
              <div className="space-y-6">
                <p className="text-5xl leading-tight font-medium text-gray-900" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  <span className="text-6xl text-gray-400">"</span>
                  期待以上の仕上がりに、<br />
                  社内から絶賛の声が<br />
                  上がりました
                </p>
                
                <div className="flex items-center gap-4">
                  <p className="text-xl font-bold text-gray-900" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    田中 美咲 様
                  </p>
                  <div className="flex items-center gap-2 px-3 py-1 bg-emerald-100 rounded-full">
                    <span className="text-xs font-medium text-emerald-700">Google</span>
                    <div className="flex gap-0.5">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-emerald-600 text-xs"></i>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-6 pt-8 border-t border-gray-200">
              <p className="text-base text-gray-700 leading-relaxed">
                新商品のパッケージデザインを依頼しました。最初のヒアリングで、私たちのブランドコンセプトを深く理解してくださり、提案されたイラストは想像を超える素晴らしいものでした。細部までこだわり抜かれたデザインは、商品の世界観を完璧に表現しており、発売後の売上も予想を大きく上回りました。
              </p>
              <p className="text-base text-gray-700 leading-relaxed">
                特に印象的だったのは、修正依頼に対する迅速かつ丁寧な対応です。私たちの要望を的確に汲み取り、より良い方向性を提案してくださる姿勢に、プロフェッショナルとしての誇りを感じました。納期も厳守していただき、安心してプロジェクトを進めることができました。
              </p>
              <p className="text-base text-gray-700 leading-relaxed">
                今後も継続的にお願いしたいと考えており、すでに次のプロジェクトの相談を始めています。信頼できるパートナーとして、長くお付き合いさせていただきたいです。
              </p>
            </div>

            <div className="pt-6">
              <p className="text-sm text-gray-500 mb-2">株式会社ナチュラルフーズ</p>
              <p className="text-sm text-gray-500">マーケティング部 部長</p>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20Japanese%20businesswoman%20portrait%2C%20confident%20smile%2C%20modern%20office%20setting%2C%20natural%20lighting%2C%20side%20angle%20view%2C%20looking%20upward%2C%20shoulder-up%20framing%2C%20clean%20white%20background%2C%20professional%20photography%2C%20elegant%20appearance&width=600&height=800&seq=testimonial001&orientation=portrait"
                alt="田中美咲様"
                className="w-full h-[600px] object-cover object-top rounded-3xl shadow-xl"
              />
            </div>
          </div>
        </div>

        <div className="mt-24 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-gray-50 rounded-2xl p-8">
            <div className="flex gap-1 mb-4">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-amber-500 text-xl"></i>
              ))}
            </div>
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              「Webサイトのイラストを依頼しました。ユーザーからの反応が非常に良く、サイト滞在時間が30%増加しました。視覚的な魅力が、ブランドイメージの向上に大きく貢献しています。」
            </p>
            <div>
              <p className="text-sm font-bold text-gray-900">佐藤 健太 様</p>
              <p className="text-xs text-gray-500">InnovateTech株式会社 CEO</p>
            </div>
          </div>

          <div className="bg-gray-50 rounded-2xl p-8">
            <div className="flex gap-1 mb-4">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-amber-500 text-xl"></i>
              ))}
            </div>
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              「児童書の挿絵をお願いしました。子どもたちの想像力を刺激する温かみのあるイラストで、読者からも出版社からも高い評価をいただいています。次作もぜひお願いしたいです。」
            </p>
            <div>
              <p className="text-sm font-bold text-gray-900">山本 由美 様</p>
              <p className="text-xs text-gray-500">作家</p>
            </div>
          </div>

          <div className="bg-gray-50 rounded-2xl p-8">
            <div className="flex gap-1 mb-4">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-amber-500 text-xl"></i>
              ))}
            </div>
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              「企業マスコットキャラクターの制作を依頼しました。社員からも顧客からも愛されるキャラクターが誕生し、ブランドの親しみやすさが格段に向上しました。大満足です。」
            </p>
            <div>
              <p className="text-sm font-bold text-gray-900">鈴木 誠 様</p>
              <p className="text-xs text-gray-500">山田商事株式会社 広報部長</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}